<template>
  <main loadingactive="[object Object]">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/report/winLose" aria-current="page"
            class="router-link-exact-active router-link-active" id="'breadcrumb1"><span
              data-v-023c5caa="">Report</span></a></li>
        <li class="breadcrumb-item"><span data-v-023c5caa="">W/L Report</span></li>
      </ol>
    </nav>
    <div data-v-023c5caa="">
      <h1 data-v-023c5caa="">W/L Report</h1>
      <div role="toolbar" class="btn-toolbar section-group mb-2">
        <div class="col-md-12 row">
          <div class="form-group row"><label for="loginName" class="col-form-label bold text-right"
              style="width: 6rem;">Login Name :</label>
            <div class="pl-4" style="width: 12rem;">
              <div class="input-group flex-nowrap clearable"><input v-model="form.input" type="text" name="loginName"
                  id="loginName" class="form-control"><span toggle="#loginName" class="toggle-username field-icon"
                  style="display: none;"><i data-v-023c5caa="" class="far fa-times"></i></span></div>
            </div>
          </div>
          <div class="form-group row pl-5"><label for="date" class="col-form-label bold text-right"
              style="width: 6rem;">Start Date :</label>
            <div class="pl-1" style="width: 12rem;">
              <div class="input-group flex-nowrap">
                <div class="mx-datepicker" id="startDate">
                  <div class="mx-input-wrapper">
                    <date-picker v-model="form.startDate" valueType="format" type="date"></date-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row pl-3"><label for="date" class="col-form-label bold text-right"
              style="width: 6rem;">To Date:</label>
            <div class="flex-1 pl-4" style="width: 12rem;">
              <div class="input-group flex-nowrap">
                <div class="mx-datepicker" id="toDate">
                  <div class="mx-input-wrapper">
                    <date-picker v-model="form.endDate" valueType="format" type="date"></date-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 row">
          <div class="form-group row"><label for="Currency" class="col-form-label bold text-right"
              style="width: 6rem;">Currency :</label>
            <div class="flex-1 pl-4" style="width: 12rem;">
              <div dir="auto" class="v-select vue-select2 vs--single vs--searchable" id="filterCurrency"
                name="Currency">
                <v-select style="width: 100%" :options='["ALL"]'>
                </v-select>
                <ul id="vs1__listbox" role="listbox" style="display: none; visibility: hidden;"></ul>
              </div>
            </div>
          </div>
          <div class="form-group row pl-3"><label for="Product" class="col-form-label bold text-right"
              style="width: 6rem;">Product :</label>
            <div class="flex-1 pl-4" style="width: 12rem;">
              <div dir="auto" class="v-select vue-select2 vs--single vs--searchable" id="filterProduct" name="Product"
                style="width: 100%;">
                <v-select style="width: 100%" :options='["ALL"]'>
                </v-select>
              </div>
            </div>
          </div>
          <div class="form-group row pl-3"><label for="Category" class="col-form-label bold text-right"
              style="width: 6rem;">Category :</label>
            <div class="flex-1 pl-4" style="width: 12rem;">
              <div dir="auto" class="v-select vue-select2 vs--single vs--searchable" id="filterCategory" name="Category"
                style="width: 100%;">
                <v-select style="width: 100%" :options='["ALL"]'>
                </v-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 row">
          <div class="row"><label for="Report" class="col-form-label bold" style="width: 6rem;">Report By :</label>
            <div class="d-flex align-items-center" style="width: 18.3rem;"><label data-v-023c5caa=""
                class="checkbox-inline pl-3"><input type="checkbox" id="reportByProduct" value="product"
                  class="chk"><label class="col-form-label" style="margin-left: 0.3rem;">Product</label></label><label
                data-v-023c5caa="" class="checkbox-inline pl-3"><input type="checkbox" id="reportByCategory"
                  value="category" class="chk"><label class="col-form-label"
                  style="margin-left: 0.3rem;">Category</label></label><label data-v-023c5caa=""
                class="checkbox-inline pl-3"><input type="checkbox" id="reportByAccount" value="account"
                  class="chk"><label class="col-form-label" style="margin-left: 0.3rem;">Account</label></label></div><a
              @keyup.enter="Search()" @click="Search()" aria-current="page"
              class="router-link-exact-active router-link-active" style="padding-left: 40px;"><a id="btn-submit"
                class="btn btn-yellow ripple-parent">Search</a></a>
          </div>
        </div>
      </div>
      <div role="toolbar" class="btn-toolbar my-4" style="margin-top: 1rem;">
        <div class="btn-group mr-auto">
          <div data-toggle="buttons" class="btn-group btn-group-green mr-3"><label data-v-023c5caa=""
              class="btn btn-white border z-depth-0 form-check-label waves-effect waves-light"><input data-v-023c5caa=""
                @click="setDateFormat('previous');" type="radio" name="options" id="option1" autocomplete="off"
                class="form-check-input"><span set-lan="text:Previous">Previous</span></label><label data-v-023c5caa=""
              class="btn btn-white border z-depth-0 form-check-label active waves-effect waves-light"><input
                @click="setDateFormat('today')" type="radio" name="options" id="option2" autocomplete="off"
                checked="checked" class="form-check-input"><span set-lan="text:Today">Today</span></label><label
              class="btn btn-white border z-depth-0 form-check-label waves-effect waves-light"><input
                @click="setDateFormat('yesterday')" type="radio" name="options" id="option3" autocomplete="off"
                class="form-check-input"><span data-v-023c5caa=""
                set-lan="text:Yesterday">Yesterday</span></label><label data-v-023c5caa=""
              class="btn btn-white border z-depth-0 form-check-label waves-effect waves-light"><input data-v-023c5caa=""
                @click="setDateFormat('week')" type="radio" name="options" id="option4" autocomplete="off"
                class="form-check-input"><span set-lan="text:This week">This Week</span></label><label
              data-v-023c5caa="" class="btn btn-white border z-depth-0 form-check-label waves-effect waves-light"><input
                data-v-023c5caa="" @click="setDateFormat('lastweek')" type="radio" name="options" id="option5"
                autocomplete="off" class="form-check-input"><span set-lan="text:Last week">Last
                Week</span></label><label data-v-023c5caa=""
              class="btn btn-white border z-depth-0 form-check-label waves-effect waves-light"><input data-v-023c5caa=""
                @click="setDateFormat('month')" type="radio" name="options" id="option6" autocomplete="off"
                class="form-check-input"><span set-lan="text:This month">This Month</span></label><label
              data-v-023c5caa="" class="btn btn-white border z-depth-0 form-check-label waves-effect waves-light"><input
                data-v-023c5caa="" @click="setDateFormat('lastmonth')" type="radio" name="options" id="option7"
                autocomplete="off" class="form-check-input"><span set-lan="text:Last month">Last
                Month</span></label><label data-v-023c5caa=""
              class="btn btn-white border z-depth-0 form-check-label waves-effect waves-light"><input data-v-023c5caa=""
                @click="setDateFormat('next')" type="radio" name="options" id="option8" autocomplete="off"
                class="form-check-input"><span set-lan="text:Next">Next</span></label></div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="/report/winLose" aria-current="page"
                  class="router-link-exact-active router-link-active" id="breadcrumb0"><a class="linkNav bold"
                    style="text-decoration: underline;">{{ getUser.username }}</a></a></li>
            </ol>
          </nav>
        </div>
      </div>
      <div data-v-023c5caa="">
        <div data-v-023c5caa="">
          <div class="report-by-currency">
            <div data-v-023c5caa="">
              <div class="yellow-bar-with-pagination">
                <pagination v-model="pageNumber" :pageSize="pageSize" :pageTotal="pageTotal" @changePage="changePage">
                </pagination>
                <div class="currency yellow-bar" style="margin-top: 16px;"><span data-v-023c5caa="">Currency :
                    THB</span></div>
                <div class="float-right" style="display: flex;">
                  <!---->
                  <!---->
                  <!---->
                  <div style="margin-bottom: 15px; margin-top: -1px;"><select data-v-023c5caa="" class="form-control"
                      style="display: block !important; width: auto;">
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="300">300</option>
                      <option value="400">400</option>
                      <option value="500">500</option>
                    </select></div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <thead data-v-023c5caa="">
                    <tr data-v-023c5caa="">
                      <th colspan="6"></th>
                      <th colspan="3" style="text-align: center;">Member</th>
                      <th colspan="3" style="text-align: center;">Agent</th>
                      <th colspan="3" style="text-align: center;">Master</th>
                      <th colspan="3" style="text-align: center;">Company</th>
                    </tr>
                    <tr data-v-023c5caa="">
                      <th class="col-text-padding" style="text-align: center; width: 1%;">No.</th>
                      <th class="col-text-padding" style="text-align: center; width: 10%;">Login Name
                      </th>
                      <th class="col-text-padding" style="text-align: center; width: 5%;">Position
                      </th>
                      <!---->
                      <!---->
                      <th class="col-text-padding" style="text-align: right; width: 5%;">No.Ticket
                      </th>
                      <th style="text-align: right; width: 5%;">Valid turn</th>
                      <th class="col-text-padding" style="text-align: right; width: 5%;"> Member W/L
                        <br data-v-023c5caa="">(100%)
                      </th>
                      <th class="col-text-padding" style="text-align: right; width: 5%;">W/L</th>
                      <th style="text-align: right; width: 5%;">Comm</th>
                      <th style="text-align: right; width: 5%;">Total</th>
                      <th class="col-text-padding" style="text-align: right; width: 5%;">W/L</th>
                      <th style="text-align: right; width: 5%;">Comm</th>
                      <th class="col-text-padding" style="text-align: right; width: 5%;">Total</th>
                      <th class="col-text-padding" style="text-align: right; width: 5%;">W/L</th>
                      <th style="text-align: right; width: 5%;">Comm</th>
                      <th class="col-text-padding" style="text-align: right; width: 5%;">Total</th>
                      <th class="col-text-padding" style="text-align: right; width: 5%;">W/L</th>
                      <th style="text-align: right; width: 5%;">Comm</th>
                      <th class="col-text-padding" style="text-align: right; width: 5%;">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-bind:key="i" v-for="(data, i) in data.Table" class="text-right">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-right">
                        <router-link :to="'/report/winlose/' + data._id">{{ data._id }}</router-link>
                      </td>
                      <td>
                        -
                      </td>
                      <td>
                        <span class="Simple">
                          {{ data.Stake }}
                        </span>
                      </td>
                      <td>
                        <span class="Simple">
                          {{ data.betAmount | formatNumber }}
                        </span>
                      </td>
                      <td>
                        0.00
                      </td>
                      <td>
                        <span v-bind:class="[
                          data.ChartList.Member > 0
                            ? 'text-success'
                            : 'text-danger',
                          'Simple',
                        ]">
                          {{ data.ChartList.Member | formatNumber }}
                        </span>
                      </td>
                      <td>0.00</td>
                      <td>
                        <span v-bind:class="[
                          data.ChartList.Member > 0
                            ? 'text-success'
                            : 'text-danger',
                          'Simple',
                        ]">
                          {{ data.ChartList.Member | formatNumber }}
                        </span>
                      </td>
                      <td>
                        <span v-bind:class="[
                          data.ChartList.Agent > 0
                            ? 'text-success'
                            : 'text-danger',
                          'Simple',
                        ]">
                          {{ data.ChartList.Agent | formatNumber }}
                        </span>
                      </td>
                      <td>0.00</td>
                      <td>
                        <span v-bind:class="[
                          data.ChartList.Agent > 0
                            ? 'text-success'
                            : 'text-danger',
                          'Simple',
                        ]">
                          {{ data.ChartList.Agent | formatNumber }}
                        </span>
                      </td>
                      <td >
                        <span v-bind:class="[
                          data.ChartList.Master >= 0
                            ? 'text-success'
                            : 'text-danger',
                          'Simple',
                        ]">
                          {{ data.ChartList.Master | formatNumber }}
                        </span>
                      </td>
                      <td >0.00</td>
                      <td>
                        <span v-bind:class="[
                          data.ChartList.Master >= 0
                            ? 'text-success'
                            : 'text-danger',
                          'Simple',
                        ]">
                          {{ data.ChartList.Master | formatNumber }}
                        </span>
                      </td>
                      <td >
                        <span v-bind:class="[
                          data.ChartList.Company >= 0
                            ? 'text-success'
                            : 'text-danger',
                          'Simple',
                        ]">
                          {{ data.ChartList.Company | formatNumber }}
                        </span>
                      </td>
                      <td>0.00</td>
                      <td>
                        <span v-bind:class="[
                          data.ChartList.Company >= 0
                            ? 'text-success'
                            : 'text-danger',
                          'Simple',
                        ]">
                          {{ data.ChartList.Company | formatNumber }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-show="data.Table.length === 0" data-v-023c5caa="">
                    <tr data-v-023c5caa="">
                      <th colspan="19" style="text-align: center;">Data not found</th>
                    </tr>
                  </tbody>
                  <tfoot v-show="data.Table.length >= 1" data-v-15f815f2="">
                    <tr data-v-15f815f2="" class="footer">
                      <td data-v-15f815f2="" style="text-align: right;">Total</td>
                      <td data-v-15f815f2="" colspan="2"></td>
                      <td data-v-15f815f2="" style="text-align: right;">{{ data.total_stake }}</td>
                      <td data-v-15f815f2=""
                        :style="{ color: (data.total_member < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }">{{
                            data.total_betAmount | formatNumber
                        }}</td>
                      <td data-v-15f815f2="" style="text-align: right;">0.00</td>
                      <td data-v-15f815f2=""
                        :style="{ color: (data.total_member < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">{{ data.total_member | formatNumber }}</td>
                      <td data-v-15f815f2=""
                        :style="{ color: (data.total_member < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">0.00</td>
                      <td data-v-15f815f2="" style="text-align: right;">{{ data.total_member | formatNumber }}</td>
                      <td data-v-15f815f2=""
                        :style="{ color: (data.total_agent < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">{{ data.total_agent | formatNumber }}</td>
                      <td data-v-15f815f2=""
                        :style="{ color: (data.total_agent < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">0.00</td>
                      <td data-v-15f815f2=""
                        :style="{ color: (data.total_agent < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">{{ data.total_agent | formatNumber }}</td>
                      <td  data-v-15f815f2=""
                        :style="{ color: (data.total_master < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">{{ data.total_master | formatNumber }}</td>
                      <td  data-v-15f815f2=""
                        :style="{ color: (data.total_master < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">0.00</td>
                      <td  data-v-15f815f2=""
                        :style="{ color: (data.total_master < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">{{ data.total_master | formatNumber }}</td>
                        <td data-v-15f815f2=""
                        :style="{ color: (data.total_company < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">{{ data.total_company | formatNumber }}</td>
                      <td data-v-15f815f2=""
                        :style="{ color: (data.total_company < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">0.00</td>
                      <td data-v-15f815f2=""
                        :style="{ color: (data.total_company < 0) ? 'rgb(212, 34, 34)' : 'rgb(0, 0, 0)' }"
                        style="text-align: right;">{{ data.total_company | formatNumber }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div class="float-right" style="display: flex;">
                <!---->
                <!---->
                <!---->
                <div style="margin-top: 15px; margin-bottom: -1px;"><select data-v-023c5caa="" class="form-control"
                    style="display: block !important; width: auto;">
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="300">300</option>
                    <option value="400">400</option>
                    <option value="500">500</option>&gt;
                  </select></div>
              </div>
              <pagination v-model="pageNumber" :pageSize="pageSize" :pageTotal="pageTotal" @changePage="changePage">
              </pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Pagination from '../../components/pagination.vue'
import DatePicker from 'vue2-datepicker';
import dayjs from 'dayjs'
import 'vue2-datepicker/index.css';
import calc from 'calculatorjs'

import Swal from "sweetalert2";
import api from '../../services/index.js'
import { mapGetters } from 'vuex'

export default {
  name: "winLose",
  data() {
    return {
      pageNumber: 1,
      pageSize: 100,
      pageTotal: 0,
      data: {
        total_betAmount: 0,
        total_stake: 0,
        total_player: 0,
        total_member: 0,
        total_agent: 0,
        total_master: 0,
        total_company: 0,
        isShowMaster: true,
        Table: [],
      },
      form: {
        startDate: dayjs(new Date()).format('YYYY-MM-DD'),
        endDate: dayjs(new Date()).format('YYYY-MM-DD'),
        input: "",
      },
    };
  },
  components: { DatePicker, Pagination, },
  computed: {
    ...mapGetters(["getUser"]),
  },
  mounted() {
    this.Search();
  },
  methods: {
    changePage(page) {
      this.pageNumber = page
      this.Search()
    },
    async setDateFormat(dateId) {
      if (dateId == 'today') {
        this.form.startDate = dayjs(new Date()).format('YYYY-MM-DD');
        this.form.endDate = dayjs(new Date()).format('YYYY-MM-DD');
      } if (dateId == 'yesterday') {
        this.form.startDate = dayjs().add(-1, 'day').format('YYYY-MM-DD');
        this.form.endDate = dayjs().add(-1, 'day').format('YYYY-MM-DD');
      } if (dateId == 'week') {
        this.form.startDate = dayjs().day(1).format('YYYY-MM-DD');
        this.form.endDate = dayjs().day(7).format('YYYY-MM-DD');
      } if (dateId == 'lastweek') {
        this.form.startDate = dayjs().day(1).add(-7, 'day').format('YYYY-MM-DD');
        this.form.endDate = dayjs().day(7).add(-7, 'day').format('YYYY-MM-DD');
      } if (dateId == 'month') {
        this.form.startDate = dayjs().startOf("month").format('YYYY-MM-DD');
        this.form.endDate = dayjs().endOf("month").format('YYYY-MM-DD');
      } if (dateId == 'lastmonth') {
        this.form.startDate = dayjs().startOf("month").add(-1, 'month').format('YYYY-MM-DD');
        this.form.endDate = dayjs().endOf("month").add(-1, 'month').format('YYYY-MM-DD');
      } if (dateId == 'previous') {
        this.form.startDate = dayjs(this.form.startDate).add(-1, 'day').format('YYYY-MM-DD');
        this.form.endDate = dayjs(this.form.endDate).add(-1, 'day').format('YYYY-MM-DD');
      } if (dateId == 'next') {
        this.form.startDate = dayjs(this.form.startDate).add(+1, 'day').format('YYYY-MM-DD');
        this.form.endDate = dayjs(this.form.endDate).add(+1, 'day').format('YYYY-MM-DD');
      }
      await this.Search();
    },
    async Search() {
      const callback = await api.post("/report/simple/" + this.form.input, {
        start_date: this.form.startDate,
        end_date: this.form.endDate,
        pageSize: parseInt(this.pageSize),
        pageNumber: parseInt(this.pageNumber)
      });
      if (callback.success == true) {
        if (!this.form.input) {
          this.data.Table = callback.data.Records;
        } else {
          this.data.Table = callback.data.Records;
        }
        this.pageTotal = callback.data.pageTotal;
        this.pageSize = callback.data.pageSize;
        
        this.data.total_betAmount = 0;
        this.data.total_player = 0;
        this.data.total_member = 0;
        this.data.total_agent = 0;
        this.data.total_master = 0;
        this.data.total_company = 0;
        this.data.total_stake = 0;
        //this.isShowMaster = false;
        for (var i = 0; i < this.data.Table.length; i++) {
          this.data.total_betAmount = calc(`${this.data.total_betAmount} + ${this.data.Table[i]["betAmount"]}`);

          if(this.data.Table[i]["ChartList"]){
            if(this.data.Table[i]["ChartList"]["Member"]){
              this.data.total_member = calc(`${this.data.total_member} + ${this.data.Table[i]["ChartList"]["Member"]}`);
            }
            if(this.data.Table[i]["ChartList"]["Agent"]){
              this.data.total_agent = calc(`${this.data.total_agent} + ${this.data.Table[i]["ChartList"]["Agent"]}`);
            }
            if(this.data.Table[i]["ChartList"]["Master"]){
              //
              this.isShowMaster = true;
              this.data.total_master = calc(`${this.data.total_master} + ${this.data.Table[i]["ChartList"]["Master"]}`);
            }
            if(this.data.Table[i]["ChartList"]["Company"]){
              this.data.total_company = calc(`${this.data.total_company} + ${this.data.Table[i]["ChartList"]["Company"]}`);
            }
          }
          this.data.total_stake = calc(`${this.data.total_stake} + ${this.data.Table[i]["Stake"]}`);
          if (!this.data.Table[i]["StakeUsers"]) {
            this.data.total_player = calc(`${this.data.total_player} + 1`);
          } else {
            this.data.total_player = calc(`${this.data.total_player} + ${this.data.Table[i]["StakeUsers"]}`);
          }
        }
      } else {
        Swal.fire("แจ้งเตือน", callback.status.message, "error");
      }
    },
  },
};
</script>
<style>
.mx-icon-double-left:after,
.mx-icon-double-left:before,
.mx-icon-double-right:after,
.mx-icon-double-right:before,
.mx-icon-left:before,
.mx-icon-right:before {
  content: "";
  position: relative;
  top: -1px;
  display: inline-block;
  width: 10px;
  height: 10px;
  vertical-align: middle;
  border-style: solid;
  border-color: currentColor;
  border-width: 2px 0 0 2px;
  border-radius: 1px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transform: rotate(-45deg) scale(.7);
  transform: rotate(-45deg) scale(.7)
}

.mx-icon-double-left:after {
  left: -4px
}

.mx-icon-double-right:before {
  left: 4px
}

.mx-icon-double-right:after,
.mx-icon-double-right:before,
.mx-icon-right:before {
  -webkit-transform: rotate(135deg) scale(.7);
  transform: rotate(135deg) scale(.7)
}

.mx-btn {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 1;
  font-size: 14px;
  font-weight: 500;
  padding: 7px 15px;
  margin: 0;
  cursor: pointer;
  background-color: transparent;
  outline: none;
  border: 1px solid rgba(0, 0, 0, .1);
  border-radius: 4px;
  color: #73879c;
  white-space: nowrap
}

.mx-btn:hover {
  border-color: #1284e7;
  color: #1284e7
}

.mx-btn-text {
  border: 0;
  padding: 0 4px;
  text-align: left;
  line-height: inherit
}

.mx-scrollbar {
  height: 100%
}

.mx-scrollbar:hover .mx-scrollbar-track {
  opacity: 1
}

.mx-scrollbar-wrap {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto
}

.mx-scrollbar-track {
  position: absolute;
  top: 2px;
  right: 2px;
  bottom: 2px;
  width: 6px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  -webkit-transition: opacity .24s ease-out;
  transition: opacity .24s ease-out
}

.mx-scrollbar-track .mx-scrollbar-thumb {
  position: absolute;
  width: 100%;
  height: 0;
  cursor: pointer;
  border-radius: inherit;
  background-color: rgba(144, 147, 153, .3);
  -webkit-transition: background-color .3s;
  transition: background-color .3s
}

.mx-zoom-in-down-enter-active,
.mx-zoom-in-down-leave-active {
  opacity: 1;
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
  -webkit-transition: opacity .3s cubic-bezier(.23, 1, .32, 1), -webkit-transform .3s cubic-bezier(.23, 1, .32, 1);
  transition: opacity .3s cubic-bezier(.23, 1, .32, 1), -webkit-transform .3s cubic-bezier(.23, 1, .32, 1);
  transition: transform .3s cubic-bezier(.23, 1, .32, 1), opacity .3s cubic-bezier(.23, 1, .32, 1);
  transition: transform .3s cubic-bezier(.23, 1, .32, 1), opacity .3s cubic-bezier(.23, 1, .32, 1), -webkit-transform .3s cubic-bezier(.23, 1, .32, 1);
  -webkit-transform-origin: center top;
  transform-origin: center top
}

.mx-zoom-in-down-enter,
.mx-zoom-in-down-leave-to {
  opacity: 0;
  -webkit-transform: scaleY(0);
  transform: scaleY(0)
}

.mx-datepicker {
  position: relative;
  display: inline-block;
  width: 210px
}

.mx-datepicker svg {
  width: 1em;
  height: 1em;
  vertical-align: -.15em;
  fill: currentColor;
  overflow: hidden
}

.mx-datepicker-range {
  width: 320px
}

.mx-datepicker-inline {
  width: auto
}

.mx-input-wrapper {
  position: relative
}

.mx-input-wrapper .mx-icon-clear {
  display: none
}

.mx-input-wrapper:hover .mx-icon-clear {
  display: block
}

.mx-input-wrapper:hover .mx-icon-clear+.mx-icon-calendar {
  display: none
}

.mx-input {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 34px;
  padding: 6px 30px;
  padding-left: 10px;
  font-size: 14px;
  line-height: 1.4;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075)
}

.mx-input:focus,
.mx-input:hover {
  border-color: #409aff
}

.mx-input.disabled,
.mx-input:disabled {
  color: #ccc;
  background-color: #f3f3f3;
  border-color: #ccc;
  cursor: not-allowed
}

.mx-input:focus {
  outline: none
}

.mx-input::-ms-clear {
  display: none
}

.mx-icon-calendar,
.mx-icon-clear {
  position: absolute;
  top: 50%;
  right: 8px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 16px;
  line-height: 1;
  color: rgba(0, 0, 0, .5);
  vertical-align: middle
}

.mx-icon-clear {
  cursor: pointer
}

.mx-icon-clear:hover {
  color: rgba(0, 0, 0, .8)
}

.mx-datepicker-main {
  font: 14px/1.5 Helvetica Neue, Helvetica, Arial, Microsoft Yahei, sans-serif;
  color: #73879c;
  background-color: #fff;
  border: 1px solid #e8e8e8
}

.mx-datepicker-popup {
  position: absolute;
  margin-top: 1px;
  margin-bottom: 1px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
  z-index: 2001
}

.mx-datepicker-sidebar {
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100px;
  padding: 6px;
  overflow: auto
}

.mx-datepicker-sidebar+.mx-datepicker-content {
  margin-left: 100px;
  border-left: 1px solid #e8e8e8
}

.mx-datepicker-body {
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

.mx-btn-shortcut {
  display: block;
  padding: 0 6px;
  line-height: 24px
}

.mx-range-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex
}

@media(max-width:750px) {
  .mx-range-wrapper {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column
  }
}

.mx-datepicker-header {
  padding: 6px 8px;
  border-bottom: 1px solid #e8e8e8
}

.mx-datepicker-footer {
  padding: 6px 8px;
  text-align: right;
  border-top: 1px solid #e8e8e8
}

.mx-calendar {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 248px;
  padding: 6px 12px
}

.mx-calendar+.mx-calendar {
  border-left: 1px solid #e8e8e8
}

.mx-calendar-header,
.mx-time-header {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 34px;
  line-height: 34px;
  text-align: center;
  overflow: hidden
}

.mx-btn-icon-double-left,
.mx-btn-icon-left {
  float: left
}

.mx-btn-icon-double-right,
.mx-btn-icon-right {
  float: right
}

.mx-calendar-header-label {
  font-size: 14px
}

.mx-calendar-decade-separator {
  margin: 0 2px
}

.mx-calendar-decade-separator:after {
  content: "~"
}

.mx-calendar-content {
  position: relative;
  height: 224px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box
}

.mx-calendar-content .cell {
  cursor: pointer
}

.mx-calendar-content .cell:hover {
  color: #73879c;
  background-color: #f3f9fe
}

.mx-calendar-content .cell.active {
  color: #fff;
  background-color: #1284e7
}

.mx-calendar-content .cell.in-range {
  color: #73879c;
  background-color: #dbedfb
}

.mx-calendar-content .cell.disabled {
  cursor: not-allowed;
  color: #ccc;
  background-color: #f3f3f3
}

.mx-calendar-week-mode .mx-date-row {
  cursor: pointer
}

.mx-calendar-week-mode .mx-date-row:hover {
  background-color: #f3f9fe
}

.mx-calendar-week-mode .mx-date-row.mx-active-week {
  background-color: #dbedfb
}

.mx-calendar-week-mode .mx-date-row .cell.active,
.mx-calendar-week-mode .mx-date-row .cell:hover {
  color: inherit;
  background-color: transparent
}

.mx-week-number {
  opacity: .5
}

.mx-table {
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle
}

.mx-table th {
  padding: 0;
  font-weight: 500
}

.mx-table td {
  padding: 0
}

.mx-table-date td,
.mx-table-date th {
  height: 32px;
  font-size: 12px
}

.mx-table-date .today {
  color: #2a90e9
}

.mx-table-date .cell.not-current-month {
  color: #ccc
}

.mx-time {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 224px;
  background: #fff
}

.mx-time+.mx-time {
  border-left: 1px solid #e8e8e8
}

.mx-calendar-time {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%
}

.mx-time-header {
  border-bottom: 1px solid #e8e8e8
}

.mx-time-content {
  height: 224px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden
}

.mx-time-columns {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden
}

.mx-time-column {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  position: relative;
  border-left: 1px solid #e8e8e8;
  text-align: center
}

.mx-time-column:first-child {
  border-left: 0
}

.mx-time-column .mx-time-list {
  margin: 0;
  padding: 0;
  list-style: none
}

.mx-time-column .mx-time-list:after {
  content: "";
  display: block;
  height: 192px
}

.mx-time-column .mx-time-item {
  cursor: pointer;
  font-size: 12px;
  height: 32px;
  line-height: 32px
}

.mx-time-column .mx-time-item:hover {
  color: #73879c;
  background-color: #f3f9fe
}

.mx-time-column .mx-time-item.active {
  color: #1284e7;
  background-color: transparent;
  font-weight: 700
}

.mx-time-column .mx-time-item.disabled {
  cursor: not-allowed;
  color: #ccc;
  background-color: #f3f3f3
}

.mx-time-option {
  cursor: pointer;
  padding: 8px 10px;
  font-size: 14px;
  line-height: 20px
}

.mx-time-option:hover {
  color: #73879c;
  background-color: #f3f9fe
}

.mx-time-option.active {
  color: #1284e7;
  background-color: transparent;
  font-weight: 700
}

.mx-time-option.disabled {
  cursor: not-allowed;
  color: #ccc;
  background-color: #f3f3f3
}

.v-select {
  position: relative;
  font-family: inherit
}

.v-select,
.v-select * {
  box-sizing: border-box
}

@-webkit-keyframes vSelectSpinner {
  0% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(1turn)
  }
}

@keyframes vSelectSpinner {
  0% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(1turn)
  }
}

.vs__fade-enter-active,
.vs__fade-leave-active {
  pointer-events: none;
  transition: opacity .15s cubic-bezier(1, .5, .8, 1)
}

.vs__fade-enter,
.vs__fade-leave-to {
  opacity: 0
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  cursor: not-allowed;
  background-color: #f8f8f8
}

.v-select[dir=rtl] .vs__actions {
  padding: 0 3px 0 6px
}

.v-select[dir=rtl] .vs__clear {
  margin-left: 6px;
  margin-right: 0
}

.v-select[dir=rtl] .vs__deselect {
  margin-left: 0;
  margin-right: 2px
}

.v-select[dir=rtl] .vs__dropdown-menu {
  text-align: right
}

.vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: flex;
  padding: 0 0 4px;
  background: none;
  border: 1px solid rgba(60, 60, 60, .26);
  border-radius: 4px;
  white-space: normal
}

.vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  padding: 0 2px;
  position: relative
}

.vs__actions {
  display: flex;
  align-items: center;
  padding: 4px 6px 0 3px
}

.vs--searchable .vs__dropdown-toggle {
  cursor: text
}

.vs--unsearchable .vs__dropdown-toggle {
  cursor: pointer
}

.vs--open .vs__dropdown-toggle {
  border-bottom-color: transparent;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0
}

.vs__open-indicator {
  fill: rgba(60, 60, 60, .5);
  transform: scale(1);
  transition: transform .15s cubic-bezier(1, -.115, .975, .855);
  transition-timing-function: cubic-bezier(1, -.115, .975, .855)
}

.vs--open .vs__open-indicator {
  transform: rotate(180deg) scale(1)
}

.vs--loading .vs__open-indicator {
  opacity: 0
}

.vs__clear {
  fill: rgba(60, 60, 60, .5);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px
}

.vs__dropdown-menu {
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  z-index: 1000;
  padding: 5px 0;
  margin: 0;
  width: 100%;
  max-height: 350px;
  min-width: 160px;
  overflow-y: auto;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .15);
  border: 1px solid rgba(60, 60, 60, .26);
  border-top-style: none;
  border-radius: 0 0 4px 4px;
  text-align: left;
  list-style: none;
  background: #fff
}

.vs__no-options {
  text-align: center
}

.vs__dropdown-option {
  line-height: 1.42857143;
  display: block;
  padding: 3px 20px;
  clear: both;
  color: #333;
  white-space: nowrap
}

.vs__dropdown-option:hover {
  cursor: pointer
}

.vs__dropdown-option--highlight {
  background: #5897fb;
  color: #fff
}

.vs__dropdown-option--disabled {
  background: inherit;
  color: rgba(60, 60, 60, .5)
}

.vs__dropdown-option--disabled:hover {
  cursor: inherit
}

.vs__selected {
  display: flex;
  align-items: center;
  background-color: #f0f0f0;
  border: 1px solid rgba(60, 60, 60, .26);
  border-radius: 4px;
  color: #333;
  line-height: 1.4;
  margin: 4px 2px 0;
  padding: 0 .25em;
  z-index: 0
}

.vs__deselect {
  display: inline-flex;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-left: 4px;
  padding: 0;
  border: 0;
  cursor: pointer;
  background: none;
  fill: rgba(60, 60, 60, .5);
  text-shadow: 0 1px 0 #fff
}

.vs--single .vs__selected {
  background-color: transparent;
  border-color: transparent
}

.vs--single.vs--open .vs__selected {
  position: absolute;
  opacity: .4
}

.vs--single.vs--searching .vs__selected {
  display: none
}

.vs__search::-webkit-search-cancel-button {
  display: none
}

.vs__search::-ms-clear,
.vs__search::-webkit-search-decoration,
.vs__search::-webkit-search-results-button,
.vs__search::-webkit-search-results-decoration {
  display: none
}

.vs__search,
.vs__search:focus {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  line-height: 1.4;
  font-size: 1em;
  border: 1px solid transparent;
  border-left: none;
  outline: none;
  margin: 4px 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
  width: 0;
  max-width: 100%;
  flex-grow: 1;
  z-index: 1
}

.vs__search::-webkit-input-placeholder {
  color: inherit
}

.vs__search::-moz-placeholder {
  color: inherit
}

.vs__search:-ms-input-placeholder {
  color: inherit
}

.vs__search::-ms-input-placeholder {
  color: inherit
}

.vs__search::placeholder {
  color: inherit
}

.vs--unsearchable .vs__search {
  opacity: 1
}

.vs--unsearchable:not(.vs--disabled) .vs__search:hover {
  cursor: pointer
}

.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
  opacity: .2
}

.vs__spinner {
  align-self: center;
  opacity: 0;
  font-size: 5px;
  text-indent: -9999em;
  overflow: hidden;
  border: .9em solid hsla(0, 0%, 39.2%, .1);
  border-left-color: rgba(60, 60, 60, .45);
  transform: translateZ(0);
  -webkit-animation: vSelectSpinner 1.1s linear infinite;
  animation: vSelectSpinner 1.1s linear infinite;
  transition: opacity .1s
}

.vs__spinner,
.vs__spinner:after {
  border-radius: 50%;
  width: 5em;
  height: 5em
}

.vs--loading .vs__spinner {
  opacity: 1
}

.swal2-popup.swal2-toast {
  flex-direction: row;
  align-items: center;
  width: auto;
  padding: .625em;
  overflow-y: hidden;
  background: #fff;
  box-shadow: 0 0 .625em #d9d9d9
}

.swal2-popup.swal2-toast .swal2-header {
  flex-direction: row;
  padding: 0
}

.swal2-popup.swal2-toast .swal2-title {
  flex-grow: 1;
  justify-content: flex-start;
  margin: 0 .6em;
  font-size: 1em
}

.swal2-popup.swal2-toast .swal2-footer {
  margin: .5em 0 0;
  padding: .5em 0 0;
  font-size: .8em
}

.swal2-popup.swal2-toast .swal2-close {
  position: static;
  width: .8em;
  height: .8em;
  line-height: .8
}

.swal2-popup.swal2-toast .swal2-content {
  justify-content: flex-start;
  padding: 0;
  font-size: 1em
}

.swal2-popup.swal2-toast .swal2-icon {
  width: 2em;
  min-width: 2em;
  height: 2em;
  margin: 0
}

.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content {
  display: flex;
  align-items: center;
  font-size: 1.8em;
  font-weight: 700
}

@media (-ms-high-contrast:active),
(-ms-high-contrast:none) {
  .swal2-popup.swal2-toast .swal2-icon .swal2-icon-content {
    font-size: .25em
  }
}

.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {
  width: 2em;
  height: 2em
}

.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line] {
  top: .875em;
  width: 1.375em
}

.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left] {
  left: .3125em
}

.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right] {
  right: .3125em
}

.swal2-popup.swal2-toast .swal2-actions {
  flex-basis: auto !important;
  width: auto;
  height: auto;
  margin: 0 .3125em
}

.swal2-popup.swal2-toast .swal2-styled {
  margin: 0 .3125em;
  padding: .3125em .625em;
  font-size: 1em
}

.swal2-popup.swal2-toast .swal2-styled:focus {
  box-shadow: 0 0 0 1px #fff, 0 0 0 3px rgba(50, 100, 150, .4)
}

.swal2-popup.swal2-toast .swal2-success {
  border-color: #a5dc86
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line] {
  position: absolute;
  width: 1.6em;
  height: 3em;
  transform: rotate(45deg);
  border-radius: 50%
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left] {
  top: -.8em;
  left: -.5em;
  transform: rotate(-45deg);
  transform-origin: 2em 2em;
  border-radius: 4em 0 0 4em
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right] {
  top: -.25em;
  left: .9375em;
  transform-origin: 0 1.5em;
  border-radius: 0 4em 4em 0
}

.swal2-popup.swal2-toast .swal2-success .swal2-success-ring {
  width: 2em;
  height: 2em
}

.swal2-popup.swal2-toast .swal2-success .swal2-success-fix {
  top: 0;
  left: .4375em;
  width: .4375em;
  height: 2.6875em
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line] {
  height: .3125em
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip] {
  top: 1.125em;
  left: .1875em;
  width: .75em
}

.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long] {
  top: .9375em;
  right: .1875em;
  width: 1.375em
}

.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip {
  -webkit-animation: swal2-toast-animate-success-line-tip .75s;
  animation: swal2-toast-animate-success-line-tip .75s
}

.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long {
  -webkit-animation: swal2-toast-animate-success-line-long .75s;
  animation: swal2-toast-animate-success-line-long .75s
}

.swal2-popup.swal2-toast.swal2-show {
  -webkit-animation: swal2-toast-show .5s;
  animation: swal2-toast-show .5s
}

.swal2-popup.swal2-toast.swal2-hide {
  -webkit-animation: swal2-toast-hide .1s forwards;
  animation: swal2-toast-hide .1s forwards
}

.swal2-container {
  display: flex;
  position: fixed;
  z-index: 1060;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: .625em;
  overflow-x: hidden;
  transition: background-color .1s;
  -webkit-overflow-scrolling: touch
}

.swal2-container.swal2-backdrop-show,
.swal2-container.swal2-noanimation {
  background: rgba(0, 0, 0, .4)
}

.swal2-container.swal2-backdrop-hide {
  background: 0 0 !important
}

.swal2-container.swal2-top {
  align-items: flex-start
}

.swal2-container.swal2-top-left,
.swal2-container.swal2-top-start {
  align-items: flex-start;
  justify-content: flex-start
}

.swal2-container.swal2-top-end,
.swal2-container.swal2-top-right {
  align-items: flex-start;
  justify-content: flex-end
}

.swal2-container.swal2-center {
  align-items: center
}

.swal2-container.swal2-center-left,
.swal2-container.swal2-center-start {
  align-items: center;
  justify-content: flex-start
}

.swal2-container.swal2-center-end,
.swal2-container.swal2-center-right {
  align-items: center;
  justify-content: flex-end
}

.swal2-container.swal2-bottom {
  align-items: flex-end
}

.swal2-container.swal2-bottom-left,
.swal2-container.swal2-bottom-start {
  align-items: flex-end;
  justify-content: flex-start
}

.swal2-container.swal2-bottom-end,
.swal2-container.swal2-bottom-right {
  align-items: flex-end;
  justify-content: flex-end
}

.swal2-container.swal2-bottom-end>:first-child,
.swal2-container.swal2-bottom-left>:first-child,
.swal2-container.swal2-bottom-right>:first-child,
.swal2-container.swal2-bottom-start>:first-child,
.swal2-container.swal2-bottom>:first-child {
  margin-top: auto
}

.swal2-container.swal2-grow-fullscreen>.swal2-modal {
  display: flex !important;
  flex: 1;
  align-self: stretch;
  justify-content: center
}

.swal2-container.swal2-grow-row>.swal2-modal {
  display: flex !important;
  flex: 1;
  align-content: center;
  justify-content: center
}

.swal2-container.swal2-grow-column {
  flex: 1;
  flex-direction: column
}

.swal2-container.swal2-grow-column.swal2-bottom,
.swal2-container.swal2-grow-column.swal2-center,
.swal2-container.swal2-grow-column.swal2-top {
  align-items: center
}

.swal2-container.swal2-grow-column.swal2-bottom-left,
.swal2-container.swal2-grow-column.swal2-bottom-start,
.swal2-container.swal2-grow-column.swal2-center-left,
.swal2-container.swal2-grow-column.swal2-center-start,
.swal2-container.swal2-grow-column.swal2-top-left,
.swal2-container.swal2-grow-column.swal2-top-start {
  align-items: flex-start
}

.swal2-container.swal2-grow-column.swal2-bottom-end,
.swal2-container.swal2-grow-column.swal2-bottom-right,
.swal2-container.swal2-grow-column.swal2-center-end,
.swal2-container.swal2-grow-column.swal2-center-right,
.swal2-container.swal2-grow-column.swal2-top-end,
.swal2-container.swal2-grow-column.swal2-top-right {
  align-items: flex-end
}

.swal2-container.swal2-grow-column>.swal2-modal {
  display: flex !important;
  flex: 1;
  align-content: center;
  justify-content: center
}

.swal2-container.swal2-no-transition {
  transition: none !important
}

.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen)>.swal2-modal {
  margin: auto
}

@media (-ms-high-contrast:active),
(-ms-high-contrast:none) {
  .swal2-container .swal2-modal {
    margin: 0 !important
  }
}

.swal2-popup {
  display: none;
  position: relative;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  width: 32em;
  max-width: 100%;
  padding: 1.25em;
  border: none;
  border-radius: .3125em;
  background: #fff;
  font-family: inherit;
  font-size: 1rem
}

.swal2-popup:focus {
  outline: 0
}

.swal2-popup.swal2-loading {
  overflow-y: hidden
}

.swal2-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.8em
}

.swal2-title {
  position: relative;
  max-width: 100%;
  margin: 0 0 .4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word
}

.swal2-actions {
  display: flex;
  z-index: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.25em auto 0
}

.swal2-actions:not(.swal2-loading) .swal2-styled[disabled] {
  opacity: .4
}

.swal2-actions:not(.swal2-loading) .swal2-styled:hover {
  background-image: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1))
}

.swal2-actions:not(.swal2-loading) .swal2-styled:active {
  background-image: linear-gradient(rgba(0, 0, 0, .2), rgba(0, 0, 0, .2))
}

.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  box-sizing: border-box;
  width: 2.5em;
  height: 2.5em;
  margin: .46875em;
  padding: 0;
  -webkit-animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  border: .25em solid transparent;
  border-radius: 100%;
  border-color: transparent;
  background-color: transparent !important;
  color: transparent !important;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

.swal2-actions.swal2-loading .swal2-styled.swal2-cancel {
  margin-right: 30px;
  margin-left: 30px
}

.swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm:after {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-left: 5px;
  -webkit-animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  border: 3px solid #999;
  border-radius: 50%;
  border-right-color: transparent;
  box-shadow: 1px 1px 1px #fff
}

.swal2-styled {
  margin: .3125em;
  padding: .625em 2em;
  box-shadow: none;
  font-weight: 500
}

.swal2-styled:not([disabled]) {
  cursor: pointer
}

.swal2-styled.swal2-confirm {
  background: initial;
  background-color: #3085d6
}

.swal2-styled.swal2-cancel,
.swal2-styled.swal2-confirm {
  border: 0;
  border-radius: .25em;
  color: #fff;
  font-size: 1.0625em
}

.swal2-styled.swal2-cancel {
  background: initial;
  background-color: #aaa
}

.swal2-styled:focus {
  outline: 0;
  box-shadow: 0 0 0 1px #fff, 0 0 0 3px rgba(50, 100, 150, .4)
}

.swal2-styled::-moz-focus-inner {
  border: 0
}

.swal2-footer {
  justify-content: center;
  margin: 1.25em 0 0;
  padding: 1em 0 0;
  border-top: 1px solid #eee;
  color: #545454;
  font-size: 1em
}

.swal2-timer-progress-bar-container {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: .25em;
  overflow: hidden;
  border-bottom-right-radius: .3125em;
  border-bottom-left-radius: .3125em
}

.swal2-timer-progress-bar {
  width: 100%;
  height: .25em;
  background: rgba(0, 0, 0, .2)
}

.swal2-image {
  max-width: 100%;
  margin: 1.25em auto
}

.swal2-close {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  width: 1.2em;
  height: 1.2em;
  padding: 0;
  overflow: hidden;
  transition: color .1s ease-out;
  border: none;
  border-radius: 0;
  background: 0 0;
  color: #ccc;
  font-family: serif;
  font-size: 2.5em;
  line-height: 1.2;
  cursor: pointer
}

.swal2-close:hover {
  transform: none;
  background: 0 0;
  color: #f27474
}

.swal2-close::-moz-focus-inner {
  border: 0
}

.swal2-content {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0 1.6em;
  color: #545454;
  font-size: 1.125em;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  word-wrap: break-word
}

.swal2-checkbox,
.swal2-file,
.swal2-input,
.swal2-radio,
.swal2-select,
.swal2-textarea {
  margin: 1em auto
}

.swal2-file,
.swal2-input,
.swal2-textarea {
  box-sizing: border-box;
  width: 100%;
  transition: border-color .3s, box-shadow .3s;
  border: 1px solid #d9d9d9;
  border-radius: .1875em;
  background: inherit;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .06);
  color: inherit;
  font-size: 1.125em
}

.swal2-file.swal2-inputerror,
.swal2-input.swal2-inputerror,
.swal2-textarea.swal2-inputerror {
  border-color: #f27474 !important;
  box-shadow: 0 0 2px #f27474 !important
}

.swal2-file:focus,
.swal2-input:focus,
.swal2-textarea:focus {
  border: 1px solid #b4dbed;
  outline: 0;
  box-shadow: 0 0 3px #c4e6f5
}

.swal2-file::-webkit-input-placeholder,
.swal2-input::-webkit-input-placeholder,
.swal2-textarea::-webkit-input-placeholder {
  color: #ccc
}

.swal2-file::-moz-placeholder,
.swal2-input::-moz-placeholder,
.swal2-textarea::-moz-placeholder {
  color: #ccc
}

.swal2-file:-ms-input-placeholder,
.swal2-input:-ms-input-placeholder,
.swal2-textarea:-ms-input-placeholder {
  color: #ccc
}

.swal2-file::-ms-input-placeholder,
.swal2-input::-ms-input-placeholder,
.swal2-textarea::-ms-input-placeholder {
  color: #ccc
}

.swal2-file::placeholder,
.swal2-input::placeholder,
.swal2-textarea::placeholder {
  color: #ccc
}

.swal2-range {
  margin: 1em auto;
  background: #fff
}

.swal2-range input {
  width: 80%
}

.swal2-range output {
  width: 20%;
  color: inherit;
  font-weight: 600;
  text-align: center
}

.swal2-range input,
.swal2-range output {
  height: 2.625em;
  padding: 0;
  font-size: 1.125em;
  line-height: 2.625em
}

.swal2-input {
  height: 2.625em;
  padding: 0 .75em
}

.swal2-input[type=number] {
  max-width: 10em
}

.swal2-file {
  background: inherit;
  font-size: 1.125em
}

.swal2-textarea {
  height: 6.75em;
  padding: .75em
}

.swal2-select {
  min-width: 50%;
  max-width: 100%;
  padding: .375em .625em;
  background: inherit;
  color: inherit;
  font-size: 1.125em
}

.swal2-checkbox,
.swal2-radio {
  align-items: center;
  justify-content: center;
  background: #fff;
  color: inherit
}

.swal2-checkbox label,
.swal2-radio label {
  margin: 0 .6em;
  font-size: 1.125em
}

.swal2-checkbox input,
.swal2-radio input {
  margin: 0 .4em
}

.swal2-validation-message {
  display: none;
  align-items: center;
  justify-content: center;
  padding: .625em;
  overflow: hidden;
  background: #f0f0f0;
  color: #666;
  font-size: 1em;
  font-weight: 300
}

.swal2-validation-message:before {
  content: "!";
  display: inline-block;
  width: 1.5em;
  min-width: 1.5em;
  height: 1.5em;
  margin: 0 .625em;
  border-radius: 50%;
  background-color: #f27474;
  color: #fff;
  font-weight: 600;
  line-height: 1.5em;
  text-align: center
}

.swal2-icon {
  position: relative;
  box-sizing: content-box;
  justify-content: center;
  width: 5em;
  height: 5em;
  margin: 1.25em auto 1.875em;
  border: .25em solid transparent;
  border-radius: 50%;
  font-family: inherit;
  line-height: 5em;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

.swal2-icon .swal2-icon-content {
  display: flex;
  align-items: center;
  font-size: 3.75em
}

.swal2-icon.swal2-error {
  border-color: #f27474;
  color: #f27474
}

.swal2-icon.swal2-error .swal2-x-mark {
  position: relative;
  flex-grow: 1
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line] {
  display: block;
  position: absolute;
  top: 2.3125em;
  width: 2.9375em;
  height: .3125em;
  border-radius: .125em;
  background-color: #f27474
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left] {
  left: 1.0625em;
  transform: rotate(45deg)
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right] {
  right: 1em;
  transform: rotate(-45deg)
}

.swal2-icon.swal2-error.swal2-icon-show {
  -webkit-animation: swal2-animate-error-icon .5s;
  animation: swal2-animate-error-icon .5s
}

.swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark {
  -webkit-animation: swal2-animate-error-x-mark .5s;
  animation: swal2-animate-error-x-mark .5s
}

.swal2-icon.swal2-warning {
  border-color: #facea8;
  color: #f8bb86
}

.swal2-icon.swal2-info {
  border-color: #9de0f6;
  color: #3fc3ee
}

.swal2-icon.swal2-question {
  border-color: #c9dae1;
  color: #87adbd
}

.swal2-icon.swal2-success {
  border-color: #a5dc86;
  color: #a5dc86
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line] {
  position: absolute;
  width: 3.75em;
  height: 7.5em;
  transform: rotate(45deg);
  border-radius: 50%
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left] {
  top: -.4375em;
  left: -2.0635em;
  transform: rotate(-45deg);
  transform-origin: 3.75em 3.75em;
  border-radius: 7.5em 0 0 7.5em
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right] {
  top: -.6875em;
  left: 1.875em;
  transform: rotate(-45deg);
  transform-origin: 0 3.75em;
  border-radius: 0 7.5em 7.5em 0
}

.swal2-icon.swal2-success .swal2-success-ring {
  position: absolute;
  z-index: 2;
  top: -.25em;
  left: -.25em;
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  border: .25em solid rgba(165, 220, 134, .3);
  border-radius: 50%
}

.swal2-icon.swal2-success .swal2-success-fix {
  position: absolute;
  z-index: 1;
  top: .5em;
  left: 1.625em;
  width: .4375em;
  height: 5.625em;
  transform: rotate(-45deg)
}

.swal2-icon.swal2-success [class^=swal2-success-line] {
  display: block;
  position: absolute;
  z-index: 2;
  height: .3125em;
  border-radius: .125em;
  background-color: #a5dc86
}

.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip] {
  top: 2.875em;
  left: .8125em;
  width: 1.5625em;
  transform: rotate(45deg)
}

.swal2-icon.swal2-success [class^=swal2-success-line][class$=long] {
  top: 2.375em;
  right: .5em;
  width: 2.9375em;
  transform: rotate(-45deg)
}

.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip {
  -webkit-animation: swal2-animate-success-line-tip .75s;
  animation: swal2-animate-success-line-tip .75s
}

.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long {
  -webkit-animation: swal2-animate-success-line-long .75s;
  animation: swal2-animate-success-line-long .75s
}

.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right {
  -webkit-animation: swal2-rotate-success-circular-line 4.25s ease-in;
  animation: swal2-rotate-success-circular-line 4.25s ease-in
}

.swal2-progress-steps {
  align-items: center;
  margin: 0 0 1.25em;
  padding: 0;
  background: inherit;
  font-weight: 600
}

.swal2-progress-steps li {
  display: inline-block;
  position: relative
}

.swal2-progress-steps .swal2-progress-step {
  z-index: 20;
  width: 2em;
  height: 2em;
  border-radius: 2em;
  background: #3085d6;
  color: #fff;
  line-height: 2em;
  text-align: center
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #3085d6
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step {
  background: #add8e6;
  color: #fff
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line {
  background: #add8e6
}

.swal2-progress-steps .swal2-progress-step-line {
  z-index: 10;
  width: 2.5em;
  height: .4em;
  margin: 0 -1px;
  background: #3085d6
}

[class^=swal2] {
  -webkit-tap-highlight-color: transparent
}

.swal2-show {
  -webkit-animation: swal2-show .3s;
  animation: swal2-show .3s
}

.swal2-hide {
  -webkit-animation: swal2-hide .15s forwards;
  animation: swal2-hide .15s forwards
}

.swal2-noanimation {
  transition: none
}

.swal2-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll
}

.swal2-rtl .swal2-close {
  right: auto;
  left: 0
}

.swal2-rtl .swal2-timer-progress-bar {
  right: 0;
  left: auto
}

@supports (-ms-accelerator:true) {
  .swal2-range input {
    width: 100% !important
  }

  .swal2-range output {
    display: none
  }
}

@media (-ms-high-contrast:active),
(-ms-high-contrast:none) {
  .swal2-range input {
    width: 100% !important
  }

  .swal2-range output {
    display: none
  }
}

@-moz-document url-prefix() {
  .swal2-close:focus {
    outline: 2px solid rgba(50, 100, 150, .4)
  }
}

@-webkit-keyframes swal2-toast-show {
  0% {
    transform: translateY(-.625em) rotate(2deg)
  }

  33% {
    transform: translateY(0) rotate(-2deg)
  }

  66% {
    transform: translateY(.3125em) rotate(2deg)
  }

  to {
    transform: translateY(0) rotate(0)
  }
}

@keyframes swal2-toast-show {
  0% {
    transform: translateY(-.625em) rotate(2deg)
  }

  33% {
    transform: translateY(0) rotate(-2deg)
  }

  66% {
    transform: translateY(.3125em) rotate(2deg)
  }

  to {
    transform: translateY(0) rotate(0)
  }
}

@-webkit-keyframes swal2-toast-hide {
  to {
    transform: rotate(1deg);
    opacity: 0
  }
}

@keyframes swal2-toast-hide {
  to {
    transform: rotate(1deg);
    opacity: 0
  }
}

@-webkit-keyframes swal2-toast-animate-success-line-tip {
  0% {
    top: .5625em;
    left: .0625em;
    width: 0
  }

  54% {
    top: .125em;
    left: .125em;
    width: 0
  }

  70% {
    top: .625em;
    left: -.25em;
    width: 1.625em
  }

  84% {
    top: 1.0625em;
    left: .75em;
    width: .5em
  }

  to {
    top: 1.125em;
    left: .1875em;
    width: .75em
  }
}

@keyframes swal2-toast-animate-success-line-tip {
  0% {
    top: .5625em;
    left: .0625em;
    width: 0
  }

  54% {
    top: .125em;
    left: .125em;
    width: 0
  }

  70% {
    top: .625em;
    left: -.25em;
    width: 1.625em
  }

  84% {
    top: 1.0625em;
    left: .75em;
    width: .5em
  }

  to {
    top: 1.125em;
    left: .1875em;
    width: .75em
  }
}

@-webkit-keyframes swal2-toast-animate-success-line-long {
  0% {
    top: 1.625em;
    right: 1.375em;
    width: 0
  }

  65% {
    top: 1.25em;
    right: .9375em;
    width: 0
  }

  84% {
    top: .9375em;
    right: 0;
    width: 1.125em
  }

  to {
    top: .9375em;
    right: .1875em;
    width: 1.375em
  }
}

@keyframes swal2-toast-animate-success-line-long {
  0% {
    top: 1.625em;
    right: 1.375em;
    width: 0
  }

  65% {
    top: 1.25em;
    right: .9375em;
    width: 0
  }

  84% {
    top: .9375em;
    right: 0;
    width: 1.125em
  }

  to {
    top: .9375em;
    right: .1875em;
    width: 1.375em
  }
}

@-webkit-keyframes swal2-show {
  0% {
    transform: scale(.7)
  }

  45% {
    transform: scale(1.05)
  }

  80% {
    transform: scale(.95)
  }

  to {
    transform: scale(1)
  }
}

@keyframes swal2-show {
  0% {
    transform: scale(.7)
  }

  45% {
    transform: scale(1.05)
  }

  80% {
    transform: scale(.95)
  }

  to {
    transform: scale(1)
  }
}

@-webkit-keyframes swal2-hide {
  0% {
    transform: scale(1);
    opacity: 1
  }

  to {
    transform: scale(.5);
    opacity: 0
  }
}

@keyframes swal2-hide {
  0% {
    transform: scale(1);
    opacity: 1
  }

  to {
    transform: scale(.5);
    opacity: 0
  }
}

@-webkit-keyframes swal2-animate-success-line-tip {
  0% {
    top: 1.1875em;
    left: .0625em;
    width: 0
  }

  54% {
    top: 1.0625em;
    left: .125em;
    width: 0
  }

  70% {
    top: 2.1875em;
    left: -.375em;
    width: 3.125em
  }

  84% {
    top: 3em;
    left: 1.3125em;
    width: 1.0625em
  }

  to {
    top: 2.8125em;
    left: .8125em;
    width: 1.5625em
  }
}

@keyframes swal2-animate-success-line-tip {
  0% {
    top: 1.1875em;
    left: .0625em;
    width: 0
  }

  54% {
    top: 1.0625em;
    left: .125em;
    width: 0
  }

  70% {
    top: 2.1875em;
    left: -.375em;
    width: 3.125em
  }

  84% {
    top: 3em;
    left: 1.3125em;
    width: 1.0625em
  }

  to {
    top: 2.8125em;
    left: .8125em;
    width: 1.5625em
  }
}

@-webkit-keyframes swal2-animate-success-line-long {
  0% {
    top: 3.375em;
    right: 2.875em;
    width: 0
  }

  65% {
    top: 3.375em;
    right: 2.875em;
    width: 0
  }

  84% {
    top: 2.1875em;
    right: 0;
    width: 3.4375em
  }

  to {
    top: 2.375em;
    right: .5em;
    width: 2.9375em
  }
}

@keyframes swal2-animate-success-line-long {
  0% {
    top: 3.375em;
    right: 2.875em;
    width: 0
  }

  65% {
    top: 3.375em;
    right: 2.875em;
    width: 0
  }

  84% {
    top: 2.1875em;
    right: 0;
    width: 3.4375em
  }

  to {
    top: 2.375em;
    right: .5em;
    width: 2.9375em
  }
}

@-webkit-keyframes swal2-rotate-success-circular-line {
  0% {
    transform: rotate(-45deg)
  }

  5% {
    transform: rotate(-45deg)
  }

  12% {
    transform: rotate(-405deg)
  }

  to {
    transform: rotate(-405deg)
  }
}

@keyframes swal2-rotate-success-circular-line {
  0% {
    transform: rotate(-45deg)
  }

  5% {
    transform: rotate(-45deg)
  }

  12% {
    transform: rotate(-405deg)
  }

  to {
    transform: rotate(-405deg)
  }
}

@-webkit-keyframes swal2-animate-error-x-mark {
  0% {
    margin-top: 1.625em;
    transform: scale(.4);
    opacity: 0
  }

  50% {
    margin-top: 1.625em;
    transform: scale(.4);
    opacity: 0
  }

  80% {
    margin-top: -.375em;
    transform: scale(1.15)
  }

  to {
    margin-top: 0;
    transform: scale(1);
    opacity: 1
  }
}

@keyframes swal2-animate-error-x-mark {
  0% {
    margin-top: 1.625em;
    transform: scale(.4);
    opacity: 0
  }

  50% {
    margin-top: 1.625em;
    transform: scale(.4);
    opacity: 0
  }

  80% {
    margin-top: -.375em;
    transform: scale(1.15)
  }

  to {
    margin-top: 0;
    transform: scale(1);
    opacity: 1
  }
}

@-webkit-keyframes swal2-animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0
  }

  to {
    transform: rotateX(0);
    opacity: 1
  }
}

@keyframes swal2-animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0
  }

  to {
    transform: rotateX(0);
    opacity: 1
  }
}

@-webkit-keyframes swal2-rotate-loading {
  0% {
    transform: rotate(0)
  }

  to {
    transform: rotate(1turn)
  }
}

@keyframes swal2-rotate-loading {
  0% {
    transform: rotate(0)
  }

  to {
    transform: rotate(1turn)
  }
}

body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  overflow: hidden
}

body.swal2-height-auto {
  height: auto !important
}

body.swal2-no-backdrop .swal2-container {
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  max-width: calc(100% - 1.25em);
  background-color: transparent !important
}

body.swal2-no-backdrop .swal2-container>.swal2-modal {
  box-shadow: 0 0 10px rgba(0, 0, 0, .4)
}

body.swal2-no-backdrop .swal2-container.swal2-top {
  top: 0;
  left: 50%;
  transform: translateX(-50%)
}

body.swal2-no-backdrop .swal2-container.swal2-top-left,
body.swal2-no-backdrop .swal2-container.swal2-top-start {
  top: 0;
  left: 0
}

body.swal2-no-backdrop .swal2-container.swal2-top-end,
body.swal2-no-backdrop .swal2-container.swal2-top-right {
  top: 0;
  right: 0
}

body.swal2-no-backdrop .swal2-container.swal2-center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}

body.swal2-no-backdrop .swal2-container.swal2-center-left,
body.swal2-no-backdrop .swal2-container.swal2-center-start {
  top: 50%;
  left: 0;
  transform: translateY(-50%)
}

body.swal2-no-backdrop .swal2-container.swal2-center-end,
body.swal2-no-backdrop .swal2-container.swal2-center-right {
  top: 50%;
  right: 0;
  transform: translateY(-50%)
}

body.swal2-no-backdrop .swal2-container.swal2-bottom {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%)
}

body.swal2-no-backdrop .swal2-container.swal2-bottom-left,
body.swal2-no-backdrop .swal2-container.swal2-bottom-start {
  bottom: 0;
  left: 0
}

body.swal2-no-backdrop .swal2-container.swal2-bottom-end,
body.swal2-no-backdrop .swal2-container.swal2-bottom-right {
  right: 0;
  bottom: 0
}

@media print {
  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
    overflow-y: scroll !important
  }

  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true] {
    display: none
  }

  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container {
    position: static !important
  }
}

body.swal2-toast-shown .swal2-container {
  background-color: transparent
}

body.swal2-toast-shown .swal2-container.swal2-top {
  top: 0;
  right: auto;
  bottom: auto;
  left: 50%;
  transform: translateX(-50%)
}

body.swal2-toast-shown .swal2-container.swal2-top-end,
body.swal2-toast-shown .swal2-container.swal2-top-right {
  top: 0;
  right: 0;
  bottom: auto;
  left: auto
}

body.swal2-toast-shown .swal2-container.swal2-top-left,
body.swal2-toast-shown .swal2-container.swal2-top-start {
  top: 0;
  right: auto;
  bottom: auto;
  left: 0
}

body.swal2-toast-shown .swal2-container.swal2-center-left,
body.swal2-toast-shown .swal2-container.swal2-center-start {
  top: 50%;
  right: auto;
  bottom: auto;
  left: 0;
  transform: translateY(-50%)
}

body.swal2-toast-shown .swal2-container.swal2-center {
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  transform: translate(-50%, -50%)
}

body.swal2-toast-shown .swal2-container.swal2-center-end,
body.swal2-toast-shown .swal2-container.swal2-center-right {
  top: 50%;
  right: 0;
  bottom: auto;
  left: auto;
  transform: translateY(-50%)
}

body.swal2-toast-shown .swal2-container.swal2-bottom-left,
body.swal2-toast-shown .swal2-container.swal2-bottom-start {
  top: auto;
  right: auto;
  bottom: 0;
  left: 0
}

body.swal2-toast-shown .swal2-container.swal2-bottom {
  top: auto;
  right: auto;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%)
}

body.swal2-toast-shown .swal2-container.swal2-bottom-end,
body.swal2-toast-shown .swal2-container.swal2-bottom-right {
  top: auto;
  right: 0;
  bottom: 0;
  left: auto
}

body.swal2-toast-column .swal2-toast {
  flex-direction: column;
  align-items: stretch
}

body.swal2-toast-column .swal2-toast .swal2-actions {
  flex: 1;
  align-self: stretch;
  height: 2.2em;
  margin-top: .3125em
}

body.swal2-toast-column .swal2-toast .swal2-loading {
  justify-content: center
}

body.swal2-toast-column .swal2-toast .swal2-input {
  height: 2em;
  margin: .3125em auto;
  font-size: 1em
}

body.swal2-toast-column .swal2-toast .swal2-validation-message {
  font-size: 1em
}

.vld-overlay,
.vld-shown {
  overflow: hidden
}

.vld-overlay {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  display: none;
  justify-content: center;
  z-index: 9999
}

.vld-overlay.is-active {
  display: flex
}

.vld-overlay.is-full-page {
  z-index: 9999;
  position: fixed
}

.vld-overlay .vld-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  opacity: .5
}

.vld-overlay .vld-icon,
.vld-parent {
  position: relative
}
</style>
